import * as React from 'react';
import { View } from 'react-native';
const ImageView = (_) => {
    return React.createElement(View, null);
};
export default ImageView;
//# sourceMappingURL=ImageView.js.map